import React, { FunctionComponent, ReactNode, useState } from 'react';

import Header from '../../components/Header';
import {
  Content,
  Container,
  Bottom,
  OverContent,
  Title,
  Loading,
} from './styles';
import Alert from '../Alert';
import Footer from '../../components/Footer';

interface Props {
  dark?: boolean;
  bottom?: ReactNode;
  overContent?: ReactNode;
  loading?: boolean;
  title?: string;
}

const Layout: FunctionComponent<Props> = ({
  children,
  dark,
  bottom,
  overContent,
  title,
  loading,
}) => {
  const [scrollPosition, setScrollPosition] = useState<number>();

  window.addEventListener('scroll', () => {
    const scroll =
      document.body.scrollHeight - (window.scrollY + window.innerHeight);

    setScrollPosition(scroll);
  });

  return (
    <>
      <Alert />
      <Container dark={dark} paddingBottom={!!overContent}>
        <Header loading={loading} />
        <Content>
          {loading ? (
            <Loading>
              <span>Carregando aguarde ...</span>
            </Loading>
          ) : (
            <>
              {title && <Title id="title">{title}</Title>}
              {children}
            </>
          )}
        </Content>
        {!loading && bottom && <Bottom>{bottom}</Bottom>}
        {!loading && overContent && (
          <OverContent scrollPosition={scrollPosition}>
            {overContent}
          </OverContent>
        )}
        <Footer scrollPosition={scrollPosition} />
      </Container>
    </>
  );
};

export default Layout;
